import './App.css';
import Heading from './components/title/title';
import Main from './components/main/main';

function App() {
  return (
    <>
      <Heading/>
        <Main />
    </>
  );
}

export default App;
